// Импорт именно из файла-константы, а не из барреля @/shared/page: баррель тянет
// breadcrumbs, а те — список роутов, и получается цикл. Гард, навешенный на роут,
// разворачивается на этапе инициализации модуля и на таком цикле падает.
import { PAGE_404_PATH } from "@/shared/page/ui/page-404/page-404-path";
import { Navigate } from "react-router-dom";

export function ToPageNotFound() {
  return <Navigate to={PAGE_404_PATH} replace />;
}
